<template>
	<div class="regform">
            <tabs>
                <tab :name="'Вход'" :selected="sign">
                    <login-form @closeform="closeForm"></login-form>
                </tab>
                <tab :name="'Регистрация'" :selected="reg">
                    <reg-form @closeform="closeForm"></reg-form>
                </tab>
            </tabs>
            <div class="close__form" >
                <i class="icon-close" @click="closeForm"></i>
            </div>
	</div>
</template>

<script>
import Tab from "../ui-components/ui-tab";
import Tabs from "../ui-components/ui-tabs";
import LoginForm from "./sig-login-form";
import RegForm from "./sig-reg-form";

export default {
  components: {
    "tabs": Tabs,
    "tab": Tab,
    "login-form": LoginForm,
    "reg-form": RegForm
  },
  props: {
    reg: {
      default: false
    },
    sign: {default:false}
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    closeForm(e) {
      this.$emit("close", false);
    }
  }
};
</script>

<style lang="less" scoped>
.regform {
  display: block;
  height: 100vh;
  width: 404px;
  background-color: #374b62;
  position: absolute;
  top: 0;
  left: 70px;
  z-index: 9;
}

.close__form {
  display: flex;
  width: 72px;
  height: 72px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  position: absolute;
  top: 0;
  right: 0;
  color: #718da8;

  i {
    cursor: pointer;

    &:hover {
      color: #fff;
    }
  }
}
</style>